import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { NgbDropdownConfig, NgbDropdownModule, NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { BnNgIdleService } from 'bn-ng-idle';
import { Subject, Subscription, timer } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppConfigService } from '../../config/app-config.service';
import { UserProfileService } from '../../modules/client/Service/UserProfile.service';
import { SessionDetailService } from '../../SessionDetailService';
import { tblCoreUser, tblUserProfile, UserProfileDetails } from '../../_models/app-models';



type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, NgbDropdownModule, NgbModalModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [NgbDropdownConfig, FormGroupDirective]
})
export class HeaderComponent implements OnInit, OnDestroy {

  @ViewChild('content') content;
  @ViewChild('contentTimeOut', { static: true }) contentTimeOut;
  private readonly _destroying$ = new Subject<void>();
  isIframe = false;
  loginDisplay = false;
  userName = "";
  eaaid = "";
  address = "";
  profile!: ProfileType;
  userProfileFormGroup: FormGroup;
  form!: FormGroup;
  selectedMenuItem = "";
  timerSubscription: Subscription
  bnIdleSubscription: Subscription;
  timeLeft: number;
  subscribeTimer: number;
  timeInMinutes: number;
  timeInSeconds: number;
  isProd: boolean;
  isUserAdmin: boolean;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private router: Router,
    private rootFormGroup: FormGroupDirective,
    config: NgbDropdownConfig,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private service: UserProfileService,
    private cd: ChangeDetectorRef,
    private bnIdle: BnNgIdleService,
    private modalService: NgbModal,
    private sessionDetails: SessionDetailService,
    private appConfigService: AppConfigService,
    private fb: FormBuilder
  ) {
    this.isProd = this.appConfigService.isProd();
    this.timeInMinutes = parseInt(this.appConfigService.getConfigByKey("timeout_in_minutes"));
    this.timeInSeconds = this.timeInMinutes * 60;
    this.isUserAdmin =
      config.autoClose = true;
    this.bnIdleSubscription = this.bnIdle.startWatching(this.timeInSeconds).subscribe((isTimedOut: boolean) => {
      if (isTimedOut && this.loginDisplay) {
        if (!this.modalService.hasOpenModals()) {
          this.modalService.open(this.contentTimeOut, {
            size: 'xs',
          });
          this.timeLeft = 60;
          this.subscribeTimer = this.timeLeft;
          this.timerSubscription = timer(1000, 2000).subscribe(val => {
            this.subscribeTimer = this.timeLeft - val;
            if (this.subscribeTimer <= 0) {
              this.resetModal();
            }
          });
        }
      }
    });
  }

  ngOnInit(): void {
    this.userProfileFormGroup = this.getUserProfileFormGroup();
    this.isIframe = window !== window.parent && !window.opener;
    this.form = this.rootFormGroup.control;
    if (sessionStorage.getItem("userName") !== null && sessionStorage.getItem("localAccountId") !== null) {

      this.GetProfileInformation();
      this.authService.instance.enableAccountStorageEvents();
    }

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          ///this.setLoginDisplay();
          const payload = result.payload as AuthenticationResult;
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        ////this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        // Perform actions related to user accounts here
        this.loginHandler(result);
      },
      error: (error) => console.log(error)
    });

  }

  get f() {
    return this.userProfileFormGroup.controls;
  }

  onOptionsSelected(value: string) {
    if (value == 'dsnap')
      this.router.navigate(["/program/dsnap"]);
    else if (value == 'rent')
      this.router.navigate(["/program/rentreimbursement"]);
    else if (value == 'sunbucks')
      this.router.navigate(["/program/sunbucks"]);
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
      this.adterLogout();
    }
  }

  // Add log out function here
  adterLogout() {
    this.loginDisplay = false;
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("localAccountId");
    sessionStorage.removeItem("serviceApiToken");
    sessionStorage.removeItem("coreUserId");
    sessionStorage.removeItem("CONSENTACK");
    this.router.navigate(["/client"]);
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  loginHandler(result) {
    if (result != null) {
      // B2C may leave account.username empty; fall back to the email claim
      const username = result.account.username
        || result.idTokenClaims?.["emails"]?.[0]
        || result.account.localAccountId;
      const localAccountId = result.account.localAccountId;

      this.service.GetApiToken(username, localAccountId).subscribe(
        tokenResponse => {
          sessionStorage.setItem("userName", username);
          sessionStorage.setItem("localAccountId", localAccountId);
          sessionStorage.setItem("serviceApiToken", tokenResponse.message);

          // Get the user profile,if it is not present create profile. we are not using CORE User for now.
          this.service.GetProfileUserByUserName(username, localAccountId).subscribe(
            response => {
              if (response == null || response.userProfileID == 0) {
                // Create Profile it is not present.
                this.service.CreateUserProfile(this.getUserProfileDetails(result)).subscribe(
                  createResponse => {
                    if (createResponse != null) {
                      this.GetProfileInformation();
                      this.setDefaultMenuSelection();
                    }
                  });
              }
              else {
                this.handleDashboardLogin(response);
                this.setDefaultMenuSelection();
              }
            });
        });
    }
  }

  profilePopUp() {
    this.modalService.open(this.content, {
      size: 'xl',
    });
  }

  GetProfileInformation() {
    let userName = sessionStorage.getItem('userName');
    let localAccountId = sessionStorage.getItem('localAccountId');

    // Fallback: if sessionStorage was cleared (e.g. page refresh), read from MSAL cached account
    if (!userName || !localAccountId) {
      const account = this.authService.instance.getActiveAccount()
        ?? this.authService.instance.getAllAccounts()?.[0];
      if (account) {
        userName = account.username || (account.idTokenClaims as any)?.["emails"]?.[0] || account.localAccountId;
        localAccountId = account.localAccountId;
        sessionStorage.setItem('userName', userName);
        sessionStorage.setItem('localAccountId', localAccountId);
      }
    }

    if (!userName || !localAccountId) return;

    this.service.GetProfileUserByUserName(userName, localAccountId).subscribe(
      Details => {
        this.handleDashboardLogin(Details);
      });
  }

  CheckAdminRole(coreUserId) {
    this.service.CheckAdminRole(coreUserId).subscribe(
      response => {
        if (response !== null) {
          this.isUserAdmin = response.isAdmin;
        }
        this.cd.detectChanges();
      });
  }

  // Added to handle login based on userprofile Object and left other method whihc handle Core User Object (line 192).
  handleDashboardLogin(response: tblUserProfile) {

    var result = new tblCoreUser();
    if (response !== null) {
      result.firstName = response.firstName;
      result.lastName = response.lastName;
      if (response.coreUserID > 0) {
        sessionStorage.setItem("coreUserId", response.coreUserID.toString());
        this.CheckAdminRole(response.coreUserID);
      }
    }
    this.setLoginDisplay(result);

  }

  // Create Profile based on B2C Profile deatils, we are not using CORE User for now.
  getUserProfileDetails(result) {
    let currentDate = new Date();


    let profileUser: tblUserProfile = {
      userProfileID: 0,
      firstName: result.idTokenClaims["given_name"],
      lastName: result.idTokenClaims["family_name"],
      address1: result.idTokenClaims["streetAddress"],
      address2: "",
      stateCode: result.idTokenClaims["state"],
      city: result.idTokenClaims["city"],
      zipCode: result.idTokenClaims["postalCode"],
      clientPreferredContactMethodID: 1,
      clientEmailAddress: result.idTokenClaims["emails"][0],
      clientPhoneNumber: "",
      isActive: true,
      coreUserID: -1,
      versionUserID: -1,
      versionReason: "user added from Azure",
      versionTime: currentDate.toJSON(),
      authId: result.idTokenClaims["emails"][0],
      accountId: result.account.localAccountId
    };

    let profileDetails: UserProfileDetails = {
      userProfile: profileUser
    }

    return profileDetails;
  }


  getUserProfileFormGroup(): FormGroup {
    return this.fb.group({
      userProfile: this.fb.group({
        userProfileID: [],
        firstName: [],
        lastName: [],
        address1: [],
        address2: [],
        stateCode: [],
        city: [],
        zipCode: [],
        clientPreferredContactMethodID: [],
        clientEmailAddress: [],
        clientPhoneNumber: [],
        coreUserID: [],
        authId: []
      })
    });
  }

  // Added to handle login based on userprofile Object and left other method whihc handle Core User Object (line 192).
  handleProfileLogin(response: tblUserProfile) {

    var result = new tblCoreUser();
    result.firstName = response.firstName;
    result.lastName = response.lastName;

    this.setLoginDisplay(result);
  }

  setLoginDisplay(result: tblCoreUser) {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    this.userName = (result.firstName || '') + (result.lastName ? ' ' + result.lastName : '');
    this.sessionDetails.setCoreUser(result);
    this.cd.detectChanges();
  }

  checkAndSetActiveAccount() {

    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  setDefaultMenuSelection() {
    this.onSelectMenuOption("dashboard");
  }

  resetModal() {
    this.timerSubscription.unsubscribe();
    this.modalService.dismissAll();
    this.logout();
  }

  StayConnected() {
    this.timerSubscription.unsubscribe();
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.bnIdleSubscription.unsubscribe();
  }

  onSelectMenuOption(value: string) {
    this.selectedMenuItem = value;
    switch (value) {
      case "sunbucks":
        this.router.navigate(["/program/sunbucks"]);
        break;
      case "dsnap":
        this.router.navigate(["/program/dsnap"]);
        break;
      case "rent":
        this.router.navigate(["/program/rentreimbursement"]);
        break;
      case "profile":
        sessionStorage.setItem("currentTab", "personalInfo");
        this.router.navigate(["/client/profileinformation"]);
        break;
      case "logout":
        this.logout();
        break;
      case "dashboard":
        this.router.navigate(["/client/dashboard"]);
        break;
      case "admin":
        this.router.navigate(["/client/admin"]);
        break;
      case "messagecenter":
        this.router.navigate(["/client/messagecenter"]);
        break;
      case "publicforms":
        this.router.navigate(["/client/publicforms"]);
        break;
      case "applications":
        this.router.navigate(["/client/applications"]);
        break;
      case "appeals":
        this.router.navigate(["/client/appeals"]);
        break;
      case "notifications":
        sessionStorage.setItem("currentTab", "notification");
        this.router.navigate(["/client/profileinformation"]);
        break;
      default:
        break;

    }
  }
}
